import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  description: {
    id: 'portal.components.courseSkeleton.description',
    defaultMessage: 'Explore the importance of character in leadership. '
      + 'Learn how to develop your character, setting the direction for your 30-day leadership journey.',
    description: 'Course skeleton loading description',
  },
  timeLabel: {
    id: 'portal.components.courseSkeleton.time.label',
    defaultMessage: 'Time',
    description: 'Time label',
  },
  accessLabel: {
    id: 'portal.components.courseSkeleton.access.label',
    defaultMessage: 'Access',
    description: 'Access label',
  },
});

export default messages;
